module.exports = __webpack_public_path__ + "static/media/icono_configuracion_inicial.e242d97f.svg";